import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  onClick?: () => void;
  className?: string;
  isCheckout?: boolean;
}
export function CTAButton({
  text = '🚀 QUIERO ACCEDER AHORA',
  onClick,
  className = '',
  isCheckout = false
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (isCheckout) {
      window.location.href = 'https://checkout.ecompradigital.online/cart/46902949970108:1';
    } else if (onClick) {
      onClick();
    } else {
      e.preventDefault();
      const target = document.getElementById('compra');
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <button onClick={handleClick} className={`cta-button w-full md:w-auto bg-brand-500 hover:bg-brand-600 text-white font-black text-lg md:text-xl py-4 px-8 rounded-full flex items-center justify-center gap-3 transition-colors duration-200 ${className}`} data-id="element-30">
      {text}
      <ArrowRight size={24} data-id="element-31" />
    </button>;
}